<template>
  <div class="individual_h">
    <PageContent>
      <StepsV2 :step="2" />
      <PanelV2
        type="w6"
        title="Provide details about your online store"
        @nextClick="commitData"
      >
        <template v-slot:title-solt>
          <BdoProgress :step="3" :total="3" />
        </template>
        <template v-slot:content-solt>
          <OnlineStore ref="appForm"  />
        </template>
      </PanelV2>
    </PageContent>
  </div>
</template>

<script>
import API from "@/api";
import OnlineStore from "../components/OnlineStore.vue";
export default {
  name: "IndividualH",
  pRouter: "IndividualG",
  components: {
    OnlineStore,
  },
  data() {
    return {
    };
  },
  methods: {
    commitData() {
      const onlineStoreList = [];
      this.$refs.appForm.formData.onlineStoreList.filter((item) => {
        onlineStoreList.push(item);
      });
      this.$refs.appForm.$refs.formData.validate((valid) => {
        if (valid) {
            const OBJdata = this.formatCommitData({onlineStoreList, sameAasHomeAddress: this.sameAasHomeAddress})

            API.addBdoProcess({
              ...OBJdata
            }).then(res => {
              if (res.success) {
                this.toNext()
              }
            })
          }
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.individual_h {
  ::v-deep .content {
    & > div {
      min-height: 298px;
    }
  }
}
</style>
